<template>
  <div>
    <div style="position: absolute;bottom: 65px;left:5px;">
      <span :class="`text-${color}`"> ファイル数[ {{ countFile() }}/10] </span
      ><br />
      <span :class="totalFileSize >= 50 ? 'text-red' : `text-${color}`">
        ファイル容量[{{ totalFileSize }}/50MB]
        <br />
      </span>
    </div>
    <div class="flex flex-col" v-show="fileUploader.files.length > 0">
      <div
        class="flex flex-col"
        style="margin-bottom: 5px"
        v-for="(file, i) in fileUploader.files"
        :key="i"
      >
        <div class="flex flex-row items-center"></div>
        <div
          :class="
            `flex flex-row border border-${color} pl-2 pr-3 py-2 bg-white`
          "
          style="border-radius:8px"
        >
          <span
            :class="`hover:text-${color}`"
            style="cursor: pointer;"
            @click="downloadOrPreview(file)"
          >
            {{ file?.display ? file?.display : file?.name }}
          </span>

          <div class="ml-auto">
            <svg
              style="cursor: pointer;"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="deleteImg(i)"
            >
              <circle
                cx="12"
                cy="12"
                r="11"
                fill="white"
                :stroke="`${colorCode}`"
                stroke-width="2"
              />
              <path
                d="M17.7071 7.70714C18.0976 7.31661 18.0976 6.68345 17.7071 6.29292C17.3166 5.9024 16.6834 5.9024 16.2929 6.29292L12 10.5858L7.70711 6.29293C7.31658 5.90241 6.68342 5.90241 6.29289 6.29293C5.90237 6.68346 5.90237 7.31662 6.29289 7.70714L10.5858 12L6.29289 16.2929C5.90237 16.6835 5.90237 17.3166 6.29289 17.7071C6.68342 18.0977 7.31658 18.0977 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0977 17.3166 18.0977 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70714Z"
                :fill="`${colorCode}`"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <slot name="uploaderInputStatus"> </slot>

    <div
      class="flex flex-row items-center"
      v-if="limitFileSize || limitFileCount"
    >
      <rejected-icn
        width="18"
        height="18"
        class="mt-1.5 ml-1 mr-1"
        style="align-self: baseline;"
      />
      <span v-if="limitFileSize" class="text-red text-lg"
        >１度に送信するファイルサイズを合計50MB以下にしてください</span
      >
      <span v-if="limitFileCount" class="text-red text-lg"
        >添付するファイル数は10以下にしてください</span
      >
    </div>
    <!-- v-show="countFile() <= 1" -->
    <div
      v-show="countFile() <= 9"
      :class="
        `flex flex-column h-48 border-dashed border-2 border-${color} rounded-full mb-4`
      "
      style="border-radius: 20px;"
      @dragover.prevent="dragOver"
      @dragleave.prevent="dragLeave"
      @drop.prevent="drop($event)"
      id="fileUploader"
    >
      <div class="flex flex-row mx-auto my-auto text-center h-10">
        <div class="flex flex-row items-center justify-center">
          <div class="flex flex-row items-baseline">
            <span :class="`text-${color} text-lg font-bold`">ファイル</span>
            <span :class="`text-${color} text-sm font-bold`">を</span>
            <span :class="`text-${color} text-lg font-bold`">ドロップ</span>
            <span :class="`text-${color} text-sm mx-1`">または</span>
          </div>
        </div>
        <div>
          <label
            for="file-upload"
            :class="
              `border-4 border-${color} h-10 rounded-full px-4 inline-flex items-center justify-center`
            "
            style="cursor: pointer;"
          >
            <attach-icn
              width="20px"
              height="20px"
              :class="`${color}-icon`"
            ></attach-icn>
            <span :class="`text-${color} text-lg font-bold`">ファイル選択</span>
          </label>
          <input
            type="file"
            accept="image/jpeg,image/png,application/pdf,.xlsx,.xls,.doc,.docx"
            style="z-index: 1; display: none"
            @change="previewFile"
            id="file-upload"
          />
          <canvas id="the-canvas" style="display:none;"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import PDFJS from 'pdfjs-dist'
import AttachIcn from '@/assets/icons/attach.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import { useFileUploader } from '@/services/useFileUploader'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useReceipts } from '@/services/receiptsToda/useReceipts'
import { useMemoryItemForm } from '@/services/politicalActionToda/useMemoryItemForm'

export default {
  name: 'AppFileUploader',

  emits: ['changed'],

  components: {
    AttachIcn,
    RejectedIcn,
  },

  props: {
    color: String,
    colorCode: {
      type: String,
      default: '#549A1D',
    },

    type: String,
  },

  setup(props, { emit }) {
    const PdfjsWorker = require('worker-loader?esModule=false&filename=[name].[contenthash].js!pdfjs-dist/build/pdf.worker.js')
    PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker()
    PDFJS.GlobalWorkerOptions.workerSrc =
      '//mozilla.github.io/pdf.js/build/pdf.worker.js'
    let { fileUploader, downloadOrPreviewFromS3 } = useFileUploader()
    const { currentPoliticalAction } = usePoliticalActions()
    const { currentReceipt } = useReceipts()
    const { additionalResources } = useMemoryItemForm()
    const limitFileSize = ref(false)
    const limitFileCount = ref(false)
    const totalFileSize = ref(0)

    onMounted(() => {
      let resources = []
      if (props.type === 'result') {
        resources = currentPoliticalAction.report.additionalResources
      } else if (props.type === 'memory') {
        resources = additionalResources.value
      } else if (props.type === 'receipt') {
        resources = currentReceipt.additionalResources
      }
      resources.forEach(document => {
        if (document.size) {
          totalFileSize.value += document.size
        }
      })
      totalFileSize.value = Math.round(totalFileSize.value / 1024 / 1024)
    })

    const dragOver = () => {
      fileUploader.dropped = 2
    }

    const dragLeave = () => {}

    const drop = e => {
      limitFileCount.value = false
      limitFileSize.value = false
      let files = Array.from(e.dataTransfer.files)

      // 複数ファイルを選択してドロップダウンした場合、ファイルの合計数が10を超えていた場合処理を終了する
      if (countFile() + files.length >= 11) {
        limitFileCount.value = true
        return
      }

      //添付したファイルサイズの合計が50MBを超えていた場合ファイルを添付せず、計算したファイルサイズを添付前の状態に戻す
      const currentFileSize = totalFileSize.value
      totalFileSize.value = totalFileSize.value * 1024 * 1024
      files.forEach(file => {
        totalFileSize.value += file.size
        limitFileSize.value = totalFileSize.value > 52428800
      })
      if (limitFileSize.value) {
        totalFileSize.value = currentFileSize
        return
      }

      // ファイルサイズを小数点第一位まで表示し、MB表示にする
      totalFileSize.value =
        Math.round((totalFileSize.value / 1024 / 1024) * Math.pow(10, 1)) /
        Math.pow(10, 1)

      // ドロップしたファイルの形式を確認する
      if (e && files) {
        let status = true
        files.forEach(file => {
          if (
            file.type.startsWith('image/png') === false &&
            file.type.startsWith('image/jpeg') === false &&
            file.type.startsWith('application/pdf') === false &&
            file.type.startsWith(
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ) === false &&
            file.type.startsWith('application/vnd.ms-excel') === false &&
            file.type.startsWith(
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ) === false &&
            file.type.startsWith('application/msword') === false
          )
            status = false
        })
        // ファイルを配列に加える
        if (status == true) {
          fileUploader.files.push(...files)
          if (props.type === 'result') {
            currentPoliticalAction.report.additionalResources.push(...files)
          } else if (props.type === 'memory') {
            additionalResources.value.push(...files)
          } else if (props.type === 'receipt') {
            currentReceipt.additionalResources.push(...files)
          }
        }
      }
      fileUploader.dropped = 0
    }

    const previewFile = e => {
      emit('changed', fileUploader.files)
      checkImageSize(e)

      if (limitFileSize.value) {
        return
      } else {
        fileUploader.files.push(...e.currentTarget.files)
        if (props.type === 'result') {
          currentPoliticalAction.report.additionalResources.push(
            ...e.currentTarget.files,
          )
        } else if (props.type === 'memory') {
          additionalResources.value.push(...e.currentTarget.files)
        } else if (props.type === 'receipt') {
          currentReceipt.additionalResources.push(...e.currentTarget.files)
        }
      }
    }

    // 画像,PDFなら別ウィンドウでプレビューを表示、エクセル、ワードならファイルをダウンロードする。
    const downloadOrPreview = async file => {
      if (!file.display) {
        // まだ保存されていない添付資料の処理
        const url = URL.createObjectURL(file)
        if (
          file.type.startsWith('image/png') === true ||
          file.type.startsWith('image/jpeg') === true ||
          file.type.startsWith('application/pdf') === true
        ) {
          window.open(url, 'imgwindow')
        } else if (
          file.type.startsWith(
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ) === true ||
          file.type.startsWith('application/vnd.ms-excel') === true ||
          file.type.startsWith(
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ) === true ||
          file.type.startsWith('application/msword') === true
        ) {
          const a = document.createElement('a')
          a.href = url
          a.download = file.name
          a.style.visibility = 'hidden'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } else {
        // 一度保存されている添付資料はs3に保存されているためAPIからs3のパスを取得し処理を行う
        if (props.type === 'result') {
          downloadOrPreviewFromS3(
            currentPoliticalAction.report.id,
            4,
            file,
            file.display,
          )
        } else if (props.type === 'memory') {
          downloadOrPreviewFromS3(
            currentPoliticalAction.memory.id,
            5,
            file,
            file.display,
          )
        } else if (props.type === 'receipt') {
          downloadOrPreviewFromS3(currentReceipt.id, 2, file, file.display)
        }
      }
    }

    const deleteImg = index => {
      fileUploader.files.splice(index, 1)
      let resources = []
      if (props.type === 'result') {
        currentPoliticalAction.report.additionalResources.splice(index, 1)
        resources = currentPoliticalAction.report.additionalResources
      } else if (props.type === 'memory') {
        additionalResources.value.splice(index, 1)
        resources = additionalResources
      } else if (props.type === 'receipt') {
        currentReceipt.additionalResources.splice(index, 1)
        resources = currentReceipt.additionalResources
      }

      //ファイルサイズの再計算
      resources.forEach(document => {
        if (document.size) {
          totalFileSize.value += document.size
        }
      })
      limitFileSize.value = totalFileSize.value > 52428800
      totalFileSize.value =
        Math.round((totalFileSize.value / 1024 / 1024) * Math.pow(10, 1)) /
        Math.pow(10, 1)
      emit('changed', fileUploader.files)
    }

    const countFile = () => {
      if (props.type === 'result') {
        return currentPoliticalAction.report.additionalResources.length
      } else if (props.type === 'memory') {
        return additionalResources.value.length
      } else if (props.type === 'receipt') {
        return currentReceipt.additionalResources.length
      }
    }

    const checkImageSize = e => {
      totalFileSize.value = 0
      limitFileSize.value = false
      let resources = []
      if (props.type === 'result') {
        resources = currentPoliticalAction.report.additionalResources
      } else if (props.type === 'memory') {
        resources = additionalResources.value
      } else if (props.type === 'receipt') {
        resources = currentReceipt.additionalResources
      }
      resources.forEach(document => {
        if (document.size) {
          totalFileSize.value += document.size
        }
      })
      totalFileSize.value += e.currentTarget.files[0].size
      limitFileSize.value = totalFileSize.value > 52428800
      if (limitFileSize.value) {
        totalFileSize.value =
          totalFileSize.value - e.currentTarget.files[0].size
      }
      totalFileSize.value =
        Math.round((totalFileSize.value / 1024 / 1024) * Math.pow(10, 1)) /
        Math.pow(10, 1)
    }

    return {
      fileUploader,
      dragOver,
      dragLeave,
      drop,
      previewFile,
      deleteImg,
      countFile,
      checkImageSize,
      limitFileSize,
      limitFileCount,
      downloadOrPreview,
      totalFileSize,
      downloadOrPreviewFromS3,
    }
  },
}
</script>
<style lang="scss">
#fileUploader {
  background: white;
}
</style>
